import { getImageUrl } from "../helpers/formatting";

export function getGoogleMarkerIcon(markerStyle) {
    if (markerStyle.customMarkerUrl) {
        let size = 35;
        if (!markerStyle.imgRatio) markerStyle.imgRatio = 1;
        return {
            url: getImageUrl(markerStyle.customMarkerUrl),
            scaledSize: new google.maps.Size(parseInt(size * markerStyle.imgRatio), size),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(size - parseInt(size / 2), size)
        };;
    } else {
        let labelY = 20;
        if (markerStyle.shape == 2) labelY = 18;
        if (markerStyle.shape == 3) labelY = 16;
        if (markerStyle.shape == 4) labelY = 15;
        return {
            path: getMarkerIconShape(markerStyle.shape),
            labelOrigin: new google.maps.Point(17, labelY),
            fillColor: markerStyle.background,
            fillOpacity: 1,
            strokeWeight: 0,
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 40),
        }
    }
}

function getMarkerIconShape(shape) {
    switch (shape) {
        case 1:
            return "M 31.042 20.287 C 31.042 31.848 17.819 43.412 17.819 43.412 C 17.819 43.412 4.598 31.848 4.598 20.287 C 4.598 10.11 15.617 3.748 24.43 8.836 C 28.522 11.199 31.042 15.563 31.042 20.287 Z";
        case 2:
            return "M28.205 3.217H6.777c-2.367 0-4.286 1.87-4.286 4.179v19.847c0 2.308 1.919 4.179 4.286 4.179h5.357l5.337 13.58 5.377-13.58h5.357c2.366 0 4.285-1.87 4.285-4.179V7.396c0-2.308-1.919-4.179-4.285-4.179";
        case 3:
            return "M1.872 17.35L9.679 2.993h15.615L33.1 17.35 17.486 44.992z";
        case 4:
            return "M 32.081 14.875 L 28.556 11.35 L 28.556 6.364 C 28.555 5.27 27.667 4.382 26.573 4.382 L 21.588 4.382 L 18.061 0.855 C 17.286 0.082 16.032 0.082 15.258 0.855 L 11.734 4.381 L 6.749 4.381 C 5.654 4.382 4.767 5.269 4.767 6.363 L 4.767 11.349 L 1.242 14.875 C 0.468 15.649 0.468 16.904 1.242 17.678 L 4.767 21.204 L 4.767 26.188 C 4.767 27.284 5.655 28.171 6.749 28.171 L 11.735 28.171 L 16.618 42.945 L 21.588 28.172 L 26.573 28.172 C 27.668 28.172 28.556 27.285 28.556 26.189 L 28.556 21.205 L 32.081 17.679 C 32.855 16.905 32.855 15.65 32.081 14.876";
    }
}